import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TimesheetAdditionalConfigurationRaw } from './types'
import { QUERY_KEY_SETTINGS_TIMESHEET_ADDITIONAL } from '@/lib/api/constants';
import { updateTimesheetAdditionalSettings } from './updateTimesheetAdditionalSettings';

/**
 * Handles saving Basic Configuration data via PUT.
 */
export function useMutationTimesheetAdditionalSettings(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: TimesheetAdditionalConfigurationRaw) => {
      // const parsed = mapTimesheetAdditionalSettingsParsedToRaw(payload)
      const { data } = await updateTimesheetAdditionalSettings({ companyId, payload });
      return data;
    },

    onError: (error) => {
      // @TODO handle error properly
      // show notification to user 
      console.error('Error saving basic settings:', error);
    },

    onSuccess: (saved) => {
      // queryClient.setQueryData(['basicConfiguration', companyId], saved);
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_SETTINGS_TIMESHEET_ADDITIONAL, companyId],
      });
      // Przełącznik weryfikacji wieku przy uldze włącza/wyłącza ikonki ulgi w panelu kierowców.
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'driverRequiredActions',
      });
    },
  });
}
